
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/indiatoday-livetv",
      function () {
        return require("private-next-pages/indiatoday-livetv.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/indiatoday-livetv"])
      });
    }
  